export const POLAND_COUNTRY_ID = 17;
export const GERMANY_COUNTRY_CODE = "DE";

export const formatTaxOfficeLabel = (taxOffice) => {
  if (!taxOffice) {
    return "";
  }

  return [taxOffice.name, taxOffice.taxOfficeNumber, taxOffice.city].filter(Boolean).join(" — ");
};

export const getTaxOfficeIdForCountry = (currentTaxOfficeId, taxOffices, countryId) => {
  if (!currentTaxOfficeId || !countryId) {
    return "";
  }

  const match = (taxOffices || []).find(
    (taxOffice) => taxOffice.taxOfficeId === Number(currentTaxOfficeId)
  );

  if (!match || match.countryId !== Number(countryId)) {
    return "";
  }

  return currentTaxOfficeId;
};

export const resolveTaxOfficeDisplayName = (entity) => {
  if (!entity?.taxOffice) {
    return "";
  }

  if (entity.taxOfficeNumber) {
    return `${entity.taxOffice}, ${entity.taxOfficeNumber}`;
  }

  return entity.taxOffice;
};

export const isPolandCountry = (countryId, countries = []) => {
  if (Number(countryId) === POLAND_COUNTRY_ID) {
    return true;
  }

  const country = countries.find((item) => item.countryId === Number(countryId));
  return country?.countryCode === "PL";
};

export const isGermanyCountry = (countryId, countries = []) => {
  const country = countries.find((item) => item.countryId === Number(countryId));
  return country?.countryCode === GERMANY_COUNTRY_CODE;
};

export const isGermanSteuerNummerMissing = (entity, countries = []) => {
  if (!isGermanyCountry(entity?.countryId, countries)) {
    return false;
  }

  return !String(entity?.steuerNummer ?? "").trim();
};

export const POLISH_XML_NAW_FIELDS = [
  { key: "name", label: "Company Name" },
  { key: "address", label: "Street" },
  { key: "houseNumber", label: "House Number" },
  { key: "postalCode", label: "Postal Code" },
  { key: "city", label: "City" },
  { key: "province", label: "Province" },
  { key: "county", label: "County" },
  { key: "municipality", label: "Municipality" },
  { key: "countryId", label: "Country" },
  { key: "postOffice", label: "Post Office" },
  { key: "vat", label: "VAT" },
];

export const getMissingPolishXmlNawFields = (entity) => {
  if (Number(entity?.countryId) !== POLAND_COUNTRY_ID) {
    return [];
  }

  return POLISH_XML_NAW_FIELDS.filter((field) => !String(entity?.[field.key] ?? "").trim()).map(
    (field) => field.label
  );
};

export const getApiErrorMessage = (error, fallbackMessage) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.title) {
    return data.title;
  }

  return error?.message || fallbackMessage;
};
